import { render, staticRenderFns } from "./moneyBoxBalanceBox.vue?vue&type=template&id=7950f4a2&"
import script from "./moneyBoxBalanceBox.vue?vue&type=script&lang=ts&"
export * from "./moneyBoxBalanceBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports